





































import { Component } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import TOCEditor from '@/components/KnowledgeBase/TOCEditor.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import PageNames from '@/router/PageNames';
import { SysKBTOCDetailsModule } from '@/store/modules/sysKBTOCDetails';

@Component({
  name: 'SysAdminTableOfContentsDetails',
  components: {
    Alert,
    TOCEditor
  }
})
export default class extends GiganautVue {
  get tocId(): string {
    return this.$route.params.id as string;
  }

  get loading() {
    return SysKBTOCDetailsModule.loading;
  }

  get tocTitle(): string {
    const toc = SysKBTOCDetailsModule.toc;
    if (toc?.draft?.title) {
      return toc.draft.title;
    }
    if (toc?.published?.title) {
      return toc.published.title;
    }
    return 'Table of Contents';
  }

  async mounted() {
    await this.loadTOC();
  }

  async loadTOC() {
    try {
      await SysKBTOCDetailsModule.getTOC(this.tocId);
    } catch (error) {
      console.error('Failed to load TOC:', error);
    }
  }

  goBack() {
    this.$router.push({ name: PageNames.SysAdminTableOfContentsList });
  }
}
